const updateAllType = 'QUOTE_UPDATE_CACHED_PAGES';
const updateDisplaySet = 'QUOTE_UPDATE_DISPLAY';
const setSearchType = 'QUOTE_UPDATE_SEARCH';
const clearStateType = 'QUOTE_CLEAR_STATE';
const clearStatePreserveSearchType = 'QUOTE_CLEAR_STATE_PRESERVE_SEARCH';

const initialState = {
  page: 1,
  pageCount: 0,
  paginate: true,
  search: '',
  display: [],
  all: {},
  current: null
};

//
// Base API calls
//
async function apiGet(url, getState){
  const response = await fetch(url, {
    method: 'GET',
    headers: new Headers({
      'Authorization': 'Bearer ' + getState().oidc.user.access_token,
      'Content-Type': 'application/json'
    })
  });

  let objectReturned;
  if (response.ok){
    objectReturned = await response.json();
  }
  else
    throw response.statusText;

  return objectReturned;
}

//
// Actions
//
export const actionCreators = {
  requestQuotes: (page=1) => async (dispatch, getState) => {
    const search = getState().quotes.search;
    let all = getState().quotes.all;
    let quotes;

    if (!(page in all)) {

      const get = 25;
      const url = `api/quotes?pageNumber=${page}&pageSize=${get}&search=${search}`;

      const result = await apiGet(url, getState);
      quotes = result['data'];
      const pageCount = result['pageCount'];

      dispatch({type: updateAllType, quotes, pageCount, page})
    } else {
      quotes = all[page];
    }

    const paginate = true;
    dispatch({type: updateDisplaySet, quotes, page, paginate})
  },
  setSearch: search => async (dispatch, getState) => {
    dispatch({type: setSearchType, search});

    search = search.toLowerCase();

    let quotes = [];
    Object.values(getState().quotes.all).forEach(page => {
      quotes = quotes.concat(page.filter(quote => {
        return (
          (quote.quoteNo && quote.quoteNo.toLowerCase().includes(search)) ||
          (quote.status && quote.status.toLowerCase().includes(search)) ||
          (quote.serviceType && quote.serviceType.toLowerCase().includes(search)) ||
          (quote.locationName && quote.locationName.toLowerCase().includes(search)) ||
          (quote.submittedDate && quote.submittedDate.includes(search))
        );
      }))
    });

    const page = 1;
    const paginate = false;
    dispatch({type: updateDisplaySet, quotes, page, paginate});
  },
  clearState: () => {return {type: clearStateType}},
  clearStatePreserveSearch: () => {return {type: clearStatePreserveSearchType}}
};

//
// Reducer
//
export const reducer = (previousState, action) => {
  previousState = previousState || initialState;

  if(action.type === updateAllType) {
    return {
      ...previousState,
      all: {
        ...previousState.all,
        [action.page]: action.quotes
      },
      pageCount: action.pageCount
    }
  }
  if(action.type === updateDisplaySet) {
    return {
      ...previousState,
      display: action.quotes,
      page: action.page,
      paginate: action.paginate
    }
  }
  if (action.type === setSearchType) {
    return {
      ...previousState,
      search: action.search
    }
  }
  if (action.type === clearStateType) {
    return {
      ...initialState,
    }
  }
  if (action.type === clearStatePreserveSearchType) {
    return {
      ...initialState,
      search: previousState.search
    }
  }

  return previousState;
};